import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ShieldCheck } from "lucide-react";
import { useConfig } from "@/hooks/useConfig";
import { telHref } from "@/lib/format";

const POLICIES = [
  ["privacy", "Privacy Policy"], ["terms", "Terms & Conditions"], ["cancellation", "Cancellation Policy"], ["refund", "Refund Policy"],
];

export default function Footer() {
  const cfg = useConfig();
  return (
    <footer className="bg-[#1E3B2E] text-[#E5D9C5] relative grain">
      <div className="container-x py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-md">
          <img src="/images/brandlogo-lg.png" alt="The Ananta Hotels" className="h-14 w-auto brightness-0 invert" loading="lazy" data-testid="footer-logo" />
          <p className="mt-6 text-sm leading-7 text-[#E5D9C5]/80">{cfg.footer_text || "Gateway to serenity. Luxury hotels and resorts across India, spread across acres of greenery with speciality dining, wellness and recreation."}</p>
          <div className="mt-6 flex items-start gap-3 text-sm"><MapPin size={16} className="mt-1 shrink-0" /><span data-testid="footer-address">The Ananta Udaipur, {cfg.address || "Village Bujhda, Tehsil Girwa Road, Kodiyat, Udaipur, Rajasthan 313031"}</span></div>
        </div>
        <div>
          <p className="eyebrow text-[#C28B5E] mb-5">Contact</p>
          <a href={telHref(cfg.contact_phone)} data-testid="footer-phone" className="flex items-center gap-3 text-sm py-1.5 hover:text-white"><Phone size={15} />{cfg.contact_phone}</a>
          {cfg.central_phone && <a href={telHref(cfg.central_phone)} data-testid="footer-central-phone" className="flex items-center gap-3 text-sm py-1.5 hover:text-white"><Phone size={15} />{cfg.central_phone} (Reservations)</a>}
          <a href={`mailto:${cfg.central_email}`} data-testid="footer-email" className="flex items-center gap-3 text-sm py-1.5 hover:text-white"><Mail size={15} />{cfg.central_email}</a>
        </div>
        <div>
          <p className="eyebrow text-[#C28B5E] mb-5">Information</p>
          <Link to="/about" className="block text-sm py-1.5 hover:text-white" data-testid="footer-about">About</Link>
          <Link to="/gallery" className="block text-sm py-1.5 hover:text-white" data-testid="footer-gallery">Gallery</Link>
          <Link to="/contact" className="block text-sm py-1.5 hover:text-white" data-testid="footer-contact">Contact Us</Link>
          {POLICIES.map(([k, l]) => (
            <Link key={k} to={`/policies/${k}`} data-testid={`footer-policy-${k}`} className="block text-sm py-1.5 hover:text-white">{l}</Link>
          ))}
        </div>
      </div>
      <div className="border-t border-[#E5D9C5]/15">
        <div className="container-x py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-[#E5D9C5]/70">
          <span>&copy; {new Date().getFullYear()} The Ananta Hotels. All rights reserved.</span>
          <span className="flex items-center gap-2"><ShieldCheck size={14} /> Secure HTTPS &middot; Guest data used only for your booking</span>
        </div>
      </div>
    </footer>
  );
}
